"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _jsxFileName = "/builds/schumacherweb/devbridge/ui-shared/549481182/shared/src/theme/icons/files/file-ppt.svg.js",
    _path;

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ReactComponent(props) {
  return React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: this
  }), _path || (_path = React.createElement("path", {
    d: "M14 3l5.4 5.4v10.8a1.8 1.8 0 01-1.8 1.8H6.8A1.8 1.8 0 015 19.2V4.8C5 3.801 5.801 3 6.8 3H14zm-.9 6.3h4.95L13.1 4.35V9.3zm-5.994 7.784c0 .133.045.24.135.324.09.083.204.124.342.124a.49.49 0 00.346-.124.42.42 0 00.135-.324.426.426 0 00-.136-.328.487.487 0 00-.345-.126.483.483 0 00-.34.126.426.426 0 00-.137.328zm4.553-1.14V15.9c0-.507-.109-.906-.326-1.195-.216-.289-.52-.434-.91-.434a.995.995 0 00-.803.37l-.03-.31h-.785v4.388h.847v-1.494a.988.988 0 00.776.334c.377 0 .676-.147.898-.441.222-.294.333-.685.333-1.174zm-.847-.061c0 .662-.202.993-.606.993-.266 0-.45-.105-.554-.314v-1.297c.1-.203.282-.305.548-.305.199 0 .35.08.455.24.105.16.157.388.157.683zm4.225.061V15.9c0-.507-.109-.906-.326-1.195-.216-.289-.52-.434-.91-.434a.995.995 0 00-.803.37l-.03-.31h-.785v4.388h.847v-1.494a.988.988 0 00.776.334c.377 0 .676-.147.898-.441.222-.294.333-.685.333-1.174zm-.847-.061c0 .662-.202.993-.607.993-.265 0-.45-.105-.553-.314v-1.297c.1-.203.282-.305.548-.305.199 0 .35.08.455.24.105.16.157.388.157.683zm2.385-2.332h-.847v.78h-.463v.62h.463v1.708c.012.6.314.9.908.9.176 0 .347-.026.513-.077v-.641a1.35 1.35 0 01-.25.02c-.126 0-.212-.025-.257-.076-.045-.05-.067-.135-.067-.252v-1.582h.542v-.62h-.542v-.78z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: this
  })));
}

var _default = ReactComponent;
exports["default"] = _default;